import * as React from "react";
const SortDown = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M12,5.0008 L11.9996,17.0858 L15.0354932,14.0516932 L15.7426,14.7588 L11.5001,19.0008 L7.2576,14.7588 L7.96470678,14.0516932 L10.9996,17.0858 L11.0003,5.0008 L12,5.0008 Z" }));
SortDown.displayName = "SortDown";
var SortDown_default = SortDown;
export {
  SortDown_default as default
};
